(function(){
  function initAddToCartRipple(){
    document.addEventListener('click', function(e){
      var btn = e.target.closest('.product-form__submit, button[name="add"]');
      if (!btn) return;
      var cs = getComputedStyle(btn);
      if (cs.position === 'static') btn.style.position = 'relative';
      btn.style.overflow = 'hidden';
      var rect = btn.getBoundingClientRect();
      var size = Math.max(rect.width, rect.height) * 1.2;
      var ripple = document.createElement('span');
      ripple.className = 'ab-ripple';
      ripple.style.width = ripple.style.height = size + 'px';
      ripple.style.left = (e.clientX - rect.left - size / 2) + 'px';
      ripple.style.top = (e.clientY - rect.top - size / 2) + 'px';
      btn.appendChild(ripple);
      setTimeout(function(){ ripple.remove(); }, 550);
    });
  }

  function initProductExtras(){
    var infoContainer = document.querySelector('.product__info-container');
    if (!infoContainer) return;

    var oldGroup = document.querySelector('.ab-accordion-group');
    if (oldGroup) {
      while (oldGroup.firstChild) { oldGroup.parentNode.insertBefore(oldGroup.firstChild, oldGroup); }
      oldGroup.remove();
    }
    var oldBadges = document.querySelector('.ab-cert-badges');
    if (oldBadges) oldBadges.remove();
    var oldStoryGrid = document.querySelector('.ab-story-grid');
    if (oldStoryGrid) oldStoryGrid.remove();
    var oldScrolly = document.querySelector('.ab-scrolly');
    if (oldScrolly) oldScrolly.remove();
    var oldCursor = document.getElementById('ab-cursor');
    if (oldCursor) oldCursor.remove();

    var shippingLine = infoContainer.querySelector('.product__tax');
    var buyButtonEl = infoContainer.querySelector('button[name="add"], product-form, .product-form__buttons, button[type="submit"]');
    if (shippingLine && buyButtonEl) {
      var buyBlock = buyButtonEl;
      while (buyBlock.parentElement && buyBlock.parentElement !== infoContainer) {
        buyBlock = buyBlock.parentElement;
      }
      if (buyBlock.parentElement === infoContainer && buyBlock !== shippingLine) {
        buyBlock.insertAdjacentElement('afterend', shippingLine);
      }
    }

    var accordions = document.querySelectorAll('.product__info-container .product__accordion');
    var desc = document.querySelector('.product__info-container .product__description');
    if (desc && !desc.querySelector('.ab-desc-label')) {
      var label = document.createElement('div');
      label.className = 'ab-desc-label';
      label.textContent = 'Sobre este producto';
      desc.insertBefore(label, desc.firstChild);
    }

    var revealEls = Array.prototype.slice.call(accordions);
    if (desc) revealEls.push(desc);
    if (!revealEls.length) return;
    revealEls.forEach(function(el){ el.classList.add('ab-pdp-reveal'); });
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealEls.forEach(function(el){ el.classList.add('ab-in'); });
      return;
    }
    function checkReveal(){
      var vh = window.innerHeight;
      var allIn = true;
      revealEls.forEach(function(el){
        if (el.classList.contains('ab-in')) return;
        var r = el.getBoundingClientRect();
        if (r.top < vh - 60 && r.bottom > 0) {
          el.classList.add('ab-in');
        } else {
          allIn = false;
        }
      });
      if (allIn && prodPollTimer) {
        clearInterval(prodPollTimer);
        prodPollTimer = null;
      }
    }
    checkReveal();
    var prodPollTimer = setInterval(checkReveal, 200);
    window.addEventListener('scroll', checkReveal, { passive: true });
    window.addEventListener('resize', checkReveal);
  }

  /* "Elige tu linea": zoom de entrada + parallax suave en las fotos.
     IMPORTANTE: el zoom en reposo de cada tarjeta NO se define aqui, se lee
     de la variable CSS --ab-zoom de cada imagen (assets/aquababy-motion.css).
     Antes estaba hardcodeado (1.22 -> 1.12) y pisaba con un style inline el
     encuadre del CSS: por eso la tarjeta de Clasicas se veia bien al principio
     y despues "se le hacia zoom" hasta llenar el cuadrado. El encuadre lo
     manda el CSS; este efecto solo lo acompania.

     El desplazamiento (parallax) solo puede usar el sobrante que deja el zoom:
     si la imagen se moviera mas que eso, apareceria un borde vacio dentro de
     la tarjeta. Como cada foto tiene un zoom distinto (vienen encuadradas
     distinto), se calcula el sobrante de TODAS y se usa el MENOR para las 3,
     asi las tres se mueven exactamente igual. */
  function initEligeLineaParallax(){
    var section = document.querySelector('[id$="__elige-linea"]');
    if (!section) return;
    var imgs = Array.prototype.slice.call(section.querySelectorAll('.card__media img'));
    if (!imgs.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    var ENTRANCE = 1.06; // cuanto mas zoom parte, antes de asentarse en --ab-zoom
    var MAX_SHIFT = 22;  // tope de desplazamiento en px

    var state = imgs.map(function(img){
      var base = parseFloat(getComputedStyle(img).getPropertyValue('--ab-zoom'));
      if (!base || isNaN(base)) base = 1.12;
      return { img: img, base: base, scale: base * ENTRANCE, translate: 0, active: false };
    });

    var running = false;

    function tick(){
      var vh = window.innerHeight;
      var stillNear = false;

      // sobrante comun: el menor de las 3 tarjetas, para que todas se muevan igual
      var maxT = MAX_SHIFT;
      state.forEach(function(s){
        var h = s.img.offsetHeight || s.img.getBoundingClientRect().height;
        var slack = (s.scale - 1) * h / 2;
        if (slack < maxT) maxT = slack;
      });
      if (maxT < 0) maxT = 0;

      state.forEach(function(s){
        var r = s.img.getBoundingClientRect();
        var center = r.top + r.height / 2;
        var dist = (vh / 2 - center) / (vh / 2 + r.height / 2);
        if (dist > 1) dist = 1;
        if (dist < -1) dist = -1;
        var targetTranslate = dist * maxT;
        var targetScale = s.active ? s.base : s.base * ENTRANCE;
        s.translate += (targetTranslate - s.translate) * 0.12;
        s.scale += (targetScale - s.scale) * 0.06;
        s.img.style.transform = 'translateY(' + s.translate.toFixed(2) + 'px) scale(' + s.scale.toFixed(3) + ')';
        if (r.bottom > -300 && r.top < vh + 300) stillNear = true;
      });
      if (stillNear) {
        requestAnimationFrame(tick);
      } else {
        running = false;
      }
    }

    function startLoop(){
      if (running) return;
      running = true;
      requestAnimationFrame(tick);
    }

    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var idx = imgs.indexOf(entry.target);
        if (idx === -1) return;
        if (entry.isIntersecting) {
          state[idx].active = true;
          startLoop();
        }
      });
    }, { rootMargin: '200px 0px' });

    imgs.forEach(function(img){ observer.observe(img); });
  }

  function init(){
    initProductExtras();
    initAddToCartRipple();
    initEligeLineaParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
